var _defs, _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAnalyticsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29.273,
    height: 29.272,
    viewBox: "0 0 29.273 29.272",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#666;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M173.715,170.669h-2.439a.61.61,0,0,0-.61.61V178.6a.61.61,0,0,0,.61.61h2.439a.61.61,0,0,0,.61-.61v-7.318A.61.61,0,0,0,173.715,170.669Z",
    transform: "translate(-160.909 -160.912)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M88.382,234.669H85.943a.61.61,0,0,0-.61.61v3.659a.61.61,0,0,0,.61.61h2.439a.61.61,0,0,0,.61-.61v-3.659A.61.61,0,0,0,88.382,234.669Z",
    transform: "translate(-80.454 -221.253)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M259.048,106.669h-2.439a.61.61,0,0,0-.61.61v10.977a.61.61,0,0,0,.61.61h2.439a.61.61,0,0,0,.61-.61V107.279A.61.61,0,0,0,259.048,106.669Z",
    transform: "translate(-241.363 -100.571)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M28.915,27.193l-7.28-7.28a12.217,12.217,0,1,0-1.725,1.725l7.28,7.28a1.219,1.219,0,1,0,1.725-1.725ZM12.2,21.957A9.757,9.757,0,1,1,21.954,12.2,9.769,9.769,0,0,1,12.2,21.957Z",
    transform: "translate(0 -0.003)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnalyticsIcon);
export default __webpack_public_path__ + "static/media/analytics-icon.ba3726c66a84c3783f0db1906c15ca93.svg";
export { ForwardRef as ReactComponent };